module.exports = __webpack_public_path__ + "static/media/icon_markets.f67e6abd.svg";